module.exports = __webpack_public_path__ + "static/media/menu-dots.c9e4e435.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/menu-dots.svg
// module id = 686
// module chunks = 0